var _path, _path2, _path3;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgPaymentNavbar(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14.2073 8.99444C14.0687 8.60488 13.8132 8.26765 13.4757 8.02891C13.1381 7.79016 12.735 7.66157 12.3215 7.66073H10.7735C10.3319 7.65842 9.90511 7.81994 9.57568 8.11408C9.24624 8.40821 9.03756 8.81405 8.99001 9.25312C8.94246 9.69219 9.0594 10.1333 9.31823 10.4911C9.57705 10.849 9.95938 11.0981 10.3913 11.1904L12.7484 11.7047C13.2304 11.8102 13.6564 12.0901 13.9445 12.4907C14.2327 12.8912 14.3626 13.384 14.3095 13.8745C14.2563 14.3651 14.0238 14.8186 13.6565 15.1481C13.2893 15.4776 12.8132 15.6598 12.3198 15.6596H10.9878C10.117 15.6596 9.37641 15.1042 9.10212 14.3276M11.6547 7.66073V5.66016M11.6547 17.6602V15.6613M3.31641 23.0379V18.7522H7.60212",
    stroke: "#777777",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M22.8428 9.84672C23.2979 12.2728 22.9345 14.7813 21.8097 16.9786C20.685 19.1758 18.8625 20.9374 16.6283 21.9868C14.3941 23.0362 11.8746 23.3141 9.46543 22.7768C7.05623 22.2395 4.89362 20.9175 3.31704 19.0181M0.941039 13.9473C0.485939 11.5212 0.849285 9.01269 1.97405 6.81544C3.09881 4.6182 4.92132 2.85662 7.15553 1.80719C9.38973 0.757764 11.9092 0.479893 14.3184 1.01719C16.7276 1.55449 18.8902 2.87655 20.4668 4.77586",
    stroke: "#777777",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M20.4674 0.756836V5.04255H16.1816",
    stroke: "#777777",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPaymentNavbar);
export default __webpack_public_path__ + "static/media/payment_navbar.95f3e4ab0870b78e5ecaeb84e56bd2af.svg";
export { ForwardRef as ReactComponent };